import { Controller } from '@hotwired/stimulus'

export class DeliveryTimeFieldController extends Controller {
  static targets = ['element', 'radio']
  static values = { current: String }

  connect () {
    this.toggleTargets(this.currentValue)
  }

  change (event) {
    this.toggleTargets(event.target.value)
    this.radioTargets.forEach(target => { target.checked = target.value === '' })
  }

  toggleTargets (value) {
    this.elementTargets.forEach(element => {
      const valuesProperties = element.dataset.deliveryTimeFieldValue.split(',')

      if (valuesProperties.includes(value)) {
        element.classList.remove('hidden')
      } else {
        element.classList.add('hidden')
      }
    })
  }
}
